import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "prevButton", "nextButton"];

  connect() {
    try {
      if (!this.hasContainerTarget) {
        return;
      }

      this.container = this.containerTarget;
      this.currentPosition = 0;
      this.isAnimating = false;
    } catch (error) {
      // Handle error silently
    }
  }

  prev() {
    const container = this.containerTarget;
    const scrollAmount = container.offsetWidth;

    if (container.scrollLeft === 0) {
      // At the start, jump to end
      container.scrollLeft = container.scrollWidth;
    } else {
      container.scrollLeft -= scrollAmount;
    }
  }

  next() {
    const container = this.containerTarget;
    const scrollAmount = container.offsetWidth;
    const maxScroll = container.scrollWidth - container.offsetWidth;

    if (container.scrollLeft >= maxScroll) {
      // At the end, jump to start
      container.scrollLeft = 0;
    } else {
      container.scrollLeft += scrollAmount;
    }
  }

  disconnect() {
    // Clean up if needed
  }
}
